import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/de/kurse')({
  component: Outlet,
})
